import { UserRole } from "@/services/types/common.types";

export const SCHOOL_ROLES: UserRole[] = [UserRole.PLATFORM_ADMIN];
/** Used for both the /institutions route guard and its sidebar entry. */
export const INSTITUTION_ROLES: UserRole[] = [
  UserRole.PLATFORM_ADMIN,
  UserRole.ADMIN,
];
/** Denied /institutions (route and sidebar entry) even though they also hold ADMIN. */
export const INSTITUTION_DENIED_ROLES: UserRole[] = [UserRole.SCHOOL_ADMIN];

/**
 * Roles that can see the Announcements sidebar entry and open its route:
 * tenant_admin (UserRole.ADMIN) only. super_admin (UserRole.PLATFORM_ADMIN) does not get it.
 */
export const ANNOUNCEMENT_ROLES: UserRole[] = [UserRole.ADMIN];

/**
 * Roles that see the Teachers and Students sidebar entries: school_admin only (a tenant
 * admin, super admin or creator does not). Sidebar only: the /teachers and /students route
 * guards are unchanged.
 */
export const SCHOOL_USERS_NAV_ROLES: UserRole[] = [UserRole.SCHOOL_ADMIN];

/** Academic Setup (route and sidebar entry): school_admin only. */
export const ACADEMIC_SETUP_ROLES: UserRole[] = [UserRole.SCHOOL_ADMIN];

/** Time Table (route and sidebar entry): school_admin only. */
export const TIME_TABLE_ROLES: UserRole[] = [UserRole.SCHOOL_ADMIN];
